export const REDIRECT_CONTROL_SURVEY_ROUTE = "/redirect-control-survey";
export const COMPLETED_CONTROL_SURVEY_ROUTE = "/completed-control-survey";
